export default __webpack_public_path__ + "static/media/promo.1374fb13.png";